import React from 'react'
import { Link } from 'react-router-dom'
import { ReactComponent as PoweredByStripe } from '../../assets/images/stripe-icons/powered-by-stripe.svg'

function SecureCheckoutBanner () {
  return (
    <div className='secure-checkout'>
      <span className='material-icons notranslate'>https</span>
      <span className='short-desc'><strong>Safe and secure</strong> checkout.</span>
      <Link className='stripe-logo' to='https://www.stripe.com' target='_blank' nofollow='true' rel='noreferrer'>
        <PoweredByStripe />
      </Link>
    </div>
  )
}

export default SecureCheckoutBanner
